import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M20.5 20.5H3.5C2.94772 20.5 2.5 20.0523 2.5 19.5V4.5C2.5 3.94772 2.94772 3.5 3.5 3.5H9.96482C10.2992 3.5 10.6114 3.6671 10.7969 3.9453L12.2031 6.0547C12.3886 6.3329 12.7008 6.5 13.0352 6.5H20.5C21.0523 6.5 21.5 6.94772 21.5 7.5V19.5C21.5 20.0523 21.0523 20.5 20.5 20.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
